import React from "react"
import { Checkbox, Col, Row, Collapse } from 'antd'
import type { CheckboxValueType } from 'antd/es/checkbox/Group'
import Spinner from '../../components/PageComponents/Spinner'
import { useTranslation } from "react-i18next"
import classes from "./styles.module.css"


import { NodeIndexOutlined } from "@ant-design/icons"
import Environment2Svg from '../../img/svg/environmentTwo'
import EventsSvg from '../../img/svg/events'
import {RoutesData} from './routes'
import { ExplorationsData } from './explor'
import { EventsData } from './events'

// Redux
import { useDispatch } from 'react-redux'
import { SearchRedux }  from '../../redux/mapPage/search'

import { useExploration } from '../../hooks/useExploration'


const { Panel } = Collapse;

interface ListData {
  id: string
  item: string
  value: string
}

interface Props{
  checkedId?: any[]
}

const CheckBoxRouteComponent: React.FC<Props> = ({ ...props } ) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { isLoading, arrayExplorationSearchData } = useExploration()


  const onChange = (list: CheckboxValueType[]) => {
    dispatch(SearchRedux(list))
  }
  
  if (isLoading)
  return (<Spinner />)

  return (
    <>

      <Checkbox.Group style={{ width: '100%' }} onChange={onChange} defaultValue={props.checkedId && props.checkedId[0]}>
        <Row>

          <div className={classes.divider}><br/><NodeIndexOutlined style={{color: "#275674", fontSize: '26px'}} /><span className={classes.dividerSpan}>{t("Διαδρομές")}</span></div>
          {RoutesData.map((data: ListData) => {
            return (
              <Col span={24} key={data.id} className={classes.checkboxGroup}>
                <Checkbox value={t( data.value)}>{t( data.item )}</Checkbox>
              </Col>
            )
          })}
          
          <span style={{display: 'inline-block', width: '100%', color: '#bfbdbd', padding: '0px 0px'}}>______________________________________</span>
          <div className={classes.divider}><br/><Environment2Svg width={26} height={26} fill="#275674" /><span className={classes.dividerSpan}>{t("Περιβάλλον")}</span></div>
          {arrayExplorationSearchData.slice(0, 8).map((data: any) => {
            return (
              <Col span={24} key={data.id} className={classes.checkboxGroup}>
                <Checkbox value={t( data.value)}>{t( data.item )}</Checkbox>
              </Col>
            )
          })}
          <Collapse ghost expandIconPosition='start' >
            <Panel header={t("Εμφάνιση όλων") + ' (' + (arrayExplorationSearchData.length) + ')'} key="1" className={classes.collapse} >

              {arrayExplorationSearchData.slice(8, arrayExplorationSearchData.length).map((data: any, index: any) => {

                return (
                  <Col span={24} key={data.id} className={classes.checkboxGroup}>
                    <Checkbox value={data.item}>{data.item}</Checkbox>
                  </Col>
                )
              })}

            </Panel>
          </Collapse>

          <span style={{display: 'inline-block', width: '100%', color: '#bfbdbd', padding: '0px 0px'}}>______________________________________</span>
          <div className={classes.divider}><br/><EventsSvg width={28} height={28} fill="#275674" /><span className={classes.dividerSpan2}>{t("Εκδηλώσεις")}</span></div>
          {EventsData.map((data: ListData) => {
            return (
              <Col span={24} key={data.id} className={classes.checkboxGroup}>
                <Checkbox value={t( data.value)}>{t( data.item )}</Checkbox>
              </Col>
            )
          })}
        </Row>
      </Checkbox.Group>
    </>
  )
}

export default CheckBoxRouteComponent